<template>
  <form @submit.prevent>
    <div class="row">
      <div class="col-12">
        <fg-input type="text"
          placeholder="Full Name"
          :class="{ 'form-group--error': $v.fullName.$error }"
          v-model="$v.fullName.$model">
        </fg-input>
      </div>
    </div>
    <div class="row" v-if="canEditRole">
      <div class="col-12">
        <select-role :validator="$v.selectedRole" />
      </div>
    </div>
    <div class="text-left">
      <p-button type="info"
        :loading="isUpdatingUser"
        @click.native.prevent="updateUser">
        Save
      </p-button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import SelectRole from '../Inputs/SelectRole.vue';
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

export default {
  name: 'EditGroupForm',
  components: {
    SelectRole
  },
  props: {
    user: Object
  },
  data() {
    return {
      fullName: "",
      selectedRole: "",
      isUpdatingUser: false
    }
  },
  validations: {
    fullName: { required },
    selectedRole: { required }
  },
  created() {
    this.fullName = this.user.full_name;
    this.selectedRole = this.user.role;
  },
  methods: {
    async updateUser() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide a name and role.')
        return;
      }

      this.isUpdatingUser = true;
      const success = await this.$store.dispatch('user/updateUser', {
        id: this.user.id,
        full_name: this.fullName,
        role_id: this.selectedRole.id
      });
      this.isUpdatingUser = false;

      if (success) {
        this.$emit('hasUpdate');
      }
    }
  },
  computed: {
    ...mapGetters('user', ['roles', 'isSuperUser']),
    canEditRole() {
      return this.isSuperUser ||
        this.roles.map((role) => { return role.id }).includes(this.selectedRole.id);
    }
  }
};
</script>
